import { render, staticRenderFns } from "./VtHeader.vue?vue&type=template&id=e07323bc&scoped=true&"
import script from "./VtHeader.vue?vue&type=script&lang=js&"
export * from "./VtHeader.vue?vue&type=script&lang=js&"
import style0 from "./VtHeader.vue?vue&type=style&index=0&id=e07323bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07323bc",
  null
  
)

export default component.exports